/** The Preferences section registry: ids, labels, icons and native symbols in one list, so the sidebar, the mobile list and the header title cannot disagree. */
import {
  Bell, Clock, Eye, Globe, LayoutList, Lock, MessageSquare, Palette, Settings2, Star,
  type LucideIcon,
} from '@/shared/ui/icons';
import { PREFERENCE_SECTION_SYMBOLS, type PreferenceSectionId } from './preferenceSectionIds';

export { PREFERENCE_SECTION_IDS, isPreferenceSectionId, type PreferenceSectionId } from './preferenceSectionIds';

export interface PreferenceSectionDefinition {
  id: PreferenceSectionId;
  label: string;
  icon: LucideIcon;
  sfSymbol: string;
}

export const PREFERENCE_SECTIONS: readonly PreferenceSectionDefinition[] = [
  { id: 'availability', label: 'Availability', icon: Clock, sfSymbol: PREFERENCE_SECTION_SYMBOLS.availability },
  { id: 'notifications', label: 'Notifications', icon: Bell, sfSymbol: PREFERENCE_SECTION_SYMBOLS.notifications },
  { id: 'priority-contacts', label: 'Priority contacts', icon: Star, sfSymbol: PREFERENCE_SECTION_SYMBOLS['priority-contacts'] },
  { id: 'navigation', label: 'Navigation', icon: LayoutList, sfSymbol: PREFERENCE_SECTION_SYMBOLS.navigation },
  { id: 'appearance', label: 'Appearance', icon: Palette, sfSymbol: PREFERENCE_SECTION_SYMBOLS.appearance },
  { id: 'messages', label: 'Messages', icon: MessageSquare, sfSymbol: PREFERENCE_SECTION_SYMBOLS.messages },
  { id: 'region', label: 'Language and region', icon: Globe, sfSymbol: PREFERENCE_SECTION_SYMBOLS.region },
  { id: 'accessibility', label: 'Accessibility', icon: Eye, sfSymbol: PREFERENCE_SECTION_SYMBOLS.accessibility },
  { id: 'privacy', label: 'Privacy', icon: Lock, sfSymbol: PREFERENCE_SECTION_SYMBOLS.privacy },
  { id: 'advanced', label: 'Advanced', icon: Settings2, sfSymbol: PREFERENCE_SECTION_SYMBOLS.advanced },
];

export const DEFAULT_PREFERENCE_SECTION: PreferenceSectionId = 'availability';

export function getPreferenceSectionLabel(id: string | null | undefined): string | null {
  return PREFERENCE_SECTIONS.find(section => section.id === (id === 'mark-as-read' ? 'messages' : id))?.label ?? null;
}
